import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice"
import { type BasePagination } from "../../../types/api.ts"
import { unknownError } from "../../../utils/handlers/handle-error"
import { getLeads } from "../../Leads/api/services"
import { type LeadListItem } from "../../Leads/types/types.ts"
import { getProjects } from "../../Projects/api/services"
import { type ProjectListItem } from "../../Projects/types/types.ts"
import { getDashboardStats } from "../api/services"
import { type DashboardStats } from "../types/types.ts"
import { dashboardSliceName } from "./dashboard.constants.ts"
import type {
  DashboardLeadFilters,
  DashboardProjectFilters
} from "./dashboard.types.ts"

export const fetchRecentProjects = createAsyncThunk<
  BasePagination<ProjectListItem>,
  DashboardProjectFilters
>(
  `${dashboardSliceName}/fetchRecentProjects`,
  async (filters, { dispatch, rejectWithValue }) => {
    const response = await getProjects(filters)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    return response?.data as BasePagination<ProjectListItem>
  }
)

export const fetchNewLeads = createAsyncThunk<
  BasePagination<LeadListItem>,
  DashboardLeadFilters
>(
  `${dashboardSliceName}/fetchNewLeads`,
  async (filters, { dispatch, rejectWithValue }) => {
    const response = await getLeads(filters)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    return response?.data as BasePagination<LeadListItem>
  }
)

export const fetchDashboardStats = createAsyncThunk<DashboardStats>(
  `${dashboardSliceName}/fetchDashboardStats`,
  async (_, { dispatch, rejectWithValue }) => {
    const response = await getDashboardStats()

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    return (
      response?.data || {
        active_projects: 0,
        new_leads: 0,
        overdue_invoices: 0,
        pending_checklists: 0
      }
    )
  }
)
